import { FighterTypeDict } from "../../../../model/Dto/Dict/FighterType";
import { ApiRequest, RequestMethod } from "../../../request";

const URL = "/api/fighter-type";

export async function getAllFighterTypesDict(
    factionId?: string,
    onlyCommon?: boolean
): Promise<FighterTypeDict[]> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.GET);
    const params = new URLSearchParams();
    if (factionId) params.append("factionId", factionId);
    if (onlyCommon) params.append("onlyCommon", "true");
    const query = params.toString();
    apiRequest.setUrl(query ? `${URL}?${query}` : URL);
    const response: any = await apiRequest.send();
    return response.data;
}
